import type { ReceiptTemplate } from '../schema';

export const ebayTemplate: ReceiptTemplate = {
  id: 'ebay',
  name: 'eBay Receipt',
  brand: 'EBAY',
  description: 'eBay purchase receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ebay-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/ebay.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 22,
        addressLines: [
          'ORDER CONFIRMATION',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ebay-order',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order #:', value: '84-72910-34567' },
          { id: 'seller', label: 'Seller:', value: 'mike_shop_2024' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'buyer', label: 'Buyer:', value: 'johndoe123' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ebay-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'VINTAGE CAMERA LENS', quantity: '1', price: '125.00', sku: '847291034' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ebay-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'item', label: 'ITEM PRICE', value: '125.00', isBold: false, isLarge: false },
          { id: 'shipping', label: 'SHIPPING', value: '8.99', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '11.05', isBold: false, isLarge: false },
          { id: 'total', label: 'ORDER TOTAL', value: '145.04', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ebay-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'PAYPAL',
        fields: [
          { id: 'txn', label: 'Transaction:', value: '847291034567' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ebay-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ESTIMATED DELIVERY:\n01/09/2026 - 01/12/2026\n\nTHANK YOU FOR YOUR PURCHASE',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

